/**
 * v0.4 D-U10 (Phase1): ホーム画面お知らせ欄の共通アイテム型。
 * Phase2 (管理者が自由文で掲示する掲示板機能、本ファイルでは未設計) が同じ型に
 * kind='bulletin' で乗れるよう、表示側 (HomeAnnouncementsList) は本型のみに依存させ、
 * 通知固有のフィールド (event_type_id / payload / recipient_id 等) を一切参照しないこと
 * (§6-0 原則1「型は有限個提供、値の組み合わせは自由」)。
 */
import { renderNotification, type NotificationPayload } from './notification-labels';

export type HomeFeedKind = 'notification' | 'bulletin';

export type HomeFeedItem = {
  id: string;
  kind: HomeFeedKind;
  title: string;
  body: string;
  createdAt: string;
  /** クリック時の遷移先。Phase1 の通知はイベント種別ごとの単一の遷移先を持たないため未設定のまま
   *  (「すべて見る」で /notifications へ飛ぶ導線のみ提供する)。Phase2 で使う想定の予約フィールド。 */
  sourceRef?: string;
};

/** GET /notifications?unread=1 の1行分 (NotificationBell.tsx / NotificationsPage.tsx と同じ形)。 */
export type NotificationItem = {
  recipient_id: string;
  notification_id: string;
  event_type_id: string;
  payload: NotificationPayload;
  read_at: string | null;
  created_at: string;
};

/** id には recipient_id ではなく notification_id を使う — 既読化 API (`POST /notifications/:id/read`)
 *  が要求する引数と一致させ、呼び出し側が別マップを持たずに済むようにするため。 */
export function notificationsToHomeFeedItems(items: NotificationItem[]): HomeFeedItem[] {
  return items.map((item) => {
    const rendered = renderNotification(item.event_type_id, item.payload);
    return {
      id: item.notification_id,
      kind: 'notification',
      title: rendered.title,
      body: rendered.body,
      createdAt: item.created_at,
    };
  });
}
